// Common app reconnection status constants
export const APP_ENABLE_SOCKET_STATUS_WARNINGS = 'APP_ENABLE_SOCKET_STATUS_WARNINGS';
export const APP_DISABLE_SOCKET_STATUS_WARNINGS = 'APP_DISABLE_SOCKET_STATUS_WARNINGS';

export const APP_START_CURRENT_BOARD_REFRESH = 'APP_START_CURRENT_BOARD_REFRESH';
export const APP_END_CURRENT_BOARD_REFRESH = 'APP_END_CURRENT_BOARD_REFRESH';

// Web App reconnection status constants
export const APP_DID_REHYDRATE_FROM_LOCAL_CACHE = 'APP_DID_REHYDRATE_FROM_LOCAL_CACHE';
